import { Registry } from '@react-registry'

export const rangeCommentDeserializer = () => {
  return { rangeComment: true }
}

Registry.register(rangeCommentDeserializer, { id: 'rangeComment', registry: 'v2.rangeComment-deserializer' })
